<template>
  <div>
    <v-menu
      ref="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="internalDates"
          :value="dateRangeText"
          :rules="rules"
          label="Elige un rango de fecha"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="internalDates"
        range
        @input="onInput"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalDates: this.value.length ? this.value : [
        new Date().toISOString().substr(0, 10),
        new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
      ],
    };
  },
  computed: {
    dateRangeText() {
      if (this.internalDates.length === 2) {
        return this.internalDates.join(' a ');
      }
      return '';
    },
  },
  watch: {
    internalDates(newVal) {
      this.$emit('input', newVal); // para v-model
      this.$emit('change', newVal); // para lógica personalizada
    },
    value(newVal) {
      this.internalDates = newVal;
    }
  },
  methods: {
    onInput(val) {
      this.internalDates = val;
    },
  },
};
</script>
